export default "__VITE_ASSET__BuY63$Rw__"